export const CONFIDENCE_TIER_OPTIONS = [
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' },
];

/** Matches the High/Medium/Low thresholds used by ConfidenceBar (>=90 High, >=70 Medium, else Low). */
export function confidenceRangeForTier(tier: string): { min?: number; max?: number } {
    if (tier === 'high') return { min: 90 };
    if (tier === 'medium') return { min: 70, max: 89 };
    if (tier === 'low') return { max: 69 };
    return {};
}
